define('auth/user',['durandal/app', 'plugins/http', 'knockout', 'jquery'], function (app, http, ko, $) {

    var viewmodel = function() {
        var self = this;
        self.isCompanyAdmin = ~app.currentUser.claims.indexOf('CompanyAdmin');

        self.userName = ko.observable('Unknown');

        self.activate = function () {
            self.userName(app.currentUser.displayName);
        };

        self.showUserDropdown = function () {
            var popup = $('#acc-opts');
            
            if (popup.is(':visible')) {
                popup.hide();
            } else {
                popup.show();
                window.setTimeout(function () {
                    popup.hide();
                }, 3000);
            }
        };

        self.logout = function () {
            app.showMessage('Are you sure you want to logout?', 'Logout?', ['Logout', 'Cancel']).then(function (response) {
                if (response && response === 'Logout') {
                    location.href = '/authentication/logout';
                }
            });
        };
    };

    return viewmodel;
});

